import { render, staticRenderFns } from "./Instapay.vue?vue&type=template&id=1322b4b4&"
import script from "./Instapay.vue?vue&type=script&lang=js&"
export * from "./Instapay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports